import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=317bfe44&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=317bfe44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317bfe44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317bfe44')) {
      api.createRecord('317bfe44', component.options)
    } else {
      api.reload('317bfe44', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=317bfe44&scoped=true&", function () {
      api.rerender('317bfe44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VQuo3VWz53qf/JS/comp/PopupBox.vue"
export default component.exports